import { getResource, postResource } from './Utils';

// import allSequences from './allSequences.js';
import store from '../store';
import iziToast from 'izitoast';

export default {
    /**
     * Cards
     */

    getCards(callback) {
        console.log('retrieving cards');
        getResource(
            `/v1/actioncards/list?locale=${encodeURIComponent('EN-US')}`
        )
            .then(res => {
                if (res.status === 'success') {
                    // commit cards to store
                    store.commit('setCards', res.actionCards);
                    if (callback) return callback();
                }
                if (res.status === 'error') console.log(res.error);
            })
            .catch(err => console.log(err));
    },

    getCardTypes() {
        getResource(`/v1/actioncardtypes/list`)
            .then(res => {
                if (res.status === 'success') {
                    // commit cards to store
                    console.log(res);
                    store.commit('setCardTypes', res.actionCardTypes);
                }
                if (res.status === 'error') console.log(res.error);
            })
            .catch(err => console.log(err));
    },

    setActiveCard(id, locale, callback) {
        console.log('get active card');
        getResource(`/v1/actioncards/single?id=${id}&locale=${locale}`)
            .then(res => {
                store.commit('setActiveCard', res.card);
                if (callback) return callback();
            })
            .catch(err => {
                console.log(err);
            });
    },

    clearActiveRecords() {
        store.commit('setActiveLocalRecord', {});
        store.commit('setActiveLocalRecordSaved', {});
    },

    /**
     * Media
     */
    getMedia(id, callback) {
        getResource(`/v1/media/single?id=${id}`)
            .then(res => {
                console.log(res);
                const media = res.media;
                store.commit('setActiveMedia', media);
                if (res.status === 'error')
                    console.log('error retrieving media', res.error);
                return res.media;
            })
            .then(media => {
                if (callback) return callback(media);
            })
            .catch(err => console.log(err));

        // store.commit('setMedia', allMedia);
    },
    getMediaByMarket(marketId, mlId, pgId, last, cont, callback) {
        let reqUrl = `marketId=${marketId}`;
        if (last) reqUrl += `&last=${last}`;
        if (mlId) reqUrl += `&mlId=${mlId}`;
        if (pgId) reqUrl += `&pgId=${pgId}`;
        getResource('/v1/markets/media', reqUrl)
            .then(res => {
                if (res.status === 'error')
                    console.log('error retrieving media', res.error);
                if (!cont) {
                    store.commit('setMedia', res.media);
                    return res;
                } else {
                    const prevMedia = store.getters.getMedia;
                    const media = prevMedia.concat(res.media);
                    store.commit('setMedia', media);
                    return res;
                }
            })
            .then(res => {
                if (callback) return callback(res);
            })
            .catch(err => {
                console.log('getMediaByMarket failed', err);
                store.commit('setMediaLoadedStatus', true);
                iziToast.error({
                    title: 'Media library',
                    message: 'Failed to load media. Please try reloading the page.',
                    position: 'topRight',
                    progressBar: false,
                });
                if (callback) callback({ status: 'error', error: err });
            });

        // store.commit('setMedia', allMedia);
    },

    getMediaByMarketForAC(marketId) {
        let reqUrl = `marketId=${marketId}`;
        getResource('/v1/media/list', reqUrl)
            .then(res => {
                if (res.status === 'error') {
                    console.log('error retrieving media', res.error);
                }
                store.commit('setMedia', res.media);
                return res;
            })
            .catch(err => console.log(err));
    },

    getMediaAssociations() {
        getResource('/v1/media/associations')
            .then(res => {
                store.commit('setAllProductGroups', res.productGroups);
                store.commit('setAllMediaLibraries', res.libraries);
            })
            .catch(err => console.log(err));
    },

    toggleUploadMedia(status) {
        store.commit('showMediaUploadModal', status);
    },

    toggleUpdateThumbModal(status) {
        store.commit('showUpdateThumbModal', status);
    },

    toggleAddMediaToCard(status) {
        store.commit('showAddMediaToCardModal', status);
    },

    toggleAddIconToCard(status) {
        store.commit('showCardIconModal', status);
    },

    toggleAddSequenceToPolicy(status) {
        store.commit('showAddSequenceToPolicyModal', status);
    },

    selectActiveMedia(media) {
        store.commit('setActiveMedia', media);
    },

    clearActiveMedia() {
        store.commit('setActiveMedia', null);
    },

    getMediaTabs() {
        getResource('/v1/medialibraries/tabs')
            .then(res => {
                store.commit('setMediaTabs', res.tabs);
            })
            .catch(err => console.log(err));
    },

    /**
    * Media Libraries
    */

    setActiveMediaLibrary(id, callback) {
        console.log('get active media library');
        getResource(`/v1/medialibraries/single?id=${id}`)
            .then(res => {
                store.commit('setActiveMediaLibrary', res.mediaLibrary);
                if (callback) return callback();
            })
            .catch(err => {
                console.log(err);
            });
    },

    /**
     * Action Cards
     */
    findMedia(card) {
        let cardType = '';

        if (card.TrainingMedia) {
            cardType = 'TrainingMedia';
        } else if (card.ActionCardMediaDto) {
            cardType = 'ActionCardMediaDto';
        }

        let media = {};

        if (store.getters.getMedia.length) {
            console.log('we already have media', store.getters.getMedia);
            console.log(cardType);
            media = store.getters.getMedia.find(obj => {
                return obj.id == card[cardType].MmId._;
            });
        } else {
            this.getMedia(() => {
                media = store.getters.getMedia.find(obj => {
                    return obj.id == card[cardType].MmId._;
                });
            });
        }

        this.selectActiveMedia(media);
        return media;
    },

    clearActiveCard() {
        store.commit('setActiveCard', null);
    },

    /**
     * Policies
     */

    getPolicies(callback) {
        getResource('/v1/policies/list')
            .then(res => {
                store.commit('setPolicies', res.policies);
                if (callback) return callback();
            })
            .catch(err => console.log(err));
    },

    setActivePolicy(policy) {
        store.commit('setActivePolicy', policy);
    },

    clearSelectedSequence() {
        store.commit('setSelectedSequence', null);
    },

    clearActivePolicy(policy) {
        store.commit('setActivePolicy', {});
    },

    getInteractionTypes() {
        return store.getters.getInteractionTypes;
    },

    setInteractionTypes(callback) {
        getResource('/v1/interactionTypes/list')
            .then(res => {
                store.commit('setInteractionTypes', res.interactionTypes);
                console.log('our interaction types', res.interactionTypes);
                return res;
            })
            .then(() => {
                if (callback) {
                    console.log('callback');
                    callback();
                }
                return;
            })
            .catch(err => console.log(err));
    },

    getTenantUsers() {
        return new Promise((resolve, reject) => {
            getResource('/v1/tenants/users')
                .then(res => resolve(res.users))
                .catch(err => reject(err));
        });
    },

    getTenantRoles() {
        return new Promise((resolve, reject) => {
            getResource('/v1/tenants/roles')
                .then(res => {
                    resolve(res.roles)
                })
                .catch(err => reject(err));
        });
    },

    /**
     * Markets
     */
    getMarkets(callback) {
        getResource('/v1/markets/list')
            .then(res => {
                store.commit('setMarkets', res.markets);
                if (!store.getters.getActiveMarket._id) {
                    store.commit('setActiveMarket', res.markets[0]);
                }
                if (res.status === 'error')
                    console.log('error retrieving markets', res.error);
                return res.markets;
            })
            .then(markets => {
                if (callback) return callback(markets);
            })
            .catch(err => console.log(err));
    },

    setActiveMarket(marketId, callback) {
        console.log('set active market')
        getResource(`/v1/markets/single?id=${marketId}`)
            .then(res => {
                if (res.status === 'success') {
                    const market = res.market;
                    if (res.cards) {
                        market.cards = res.cards;
                    }
                    if (res.activityPhrases) {
                        market.activityPhrases = res.activityPhrases.content;
                        market.hasPhrases = true;
                    } else {
                        market.hasPhrases = false;
                        market.activityPhrases = {};
                    }
                    if (res.cards) {
                        market.mediaRecords = res.mediaRecords;
                    }
                    if (res.cards) {
                        market.products = res.products;
                    }

                    if (res.volumeLinks) {
                        market.volumeLinks = res.volumeLinks;
                    }

                    if (res.productGroups) {
                        market.productGroups = res.productGroups;
                    }
                    return store.commit('setActiveMarket', market);
                }
            })
            .then(() => {
                if (callback) return callback();
            })
            .catch(err => console.log(err));
    },

    clearActiveMarket() {
        store.commit('setActiveMarket', {});
    },

    /**
     * Sequences
     */

    getSequences() {
        getResource('/v1/sequences/list')
            .then(res => {
                store.commit('setSequences', res.sequences);
            })
            .catch(err => console.log(err));
        // store.commit('setSequences', allSequences);
    },

    setActiveSequence(sequenceId, callback) {
        console.log('setting a new sequence', sequenceId);

        getResource(`/v1/sequences/single?sequenceId=${sequenceId}`)
            .then(res => {
                console.log('found sequence', res.sequence)
                if (res.sequence.actionCards) {
                    store.commit('setSequenceCards', res.sequence.actionCards);
                }
                return store.commit('setActiveSequence', res.sequence);
            })
            .then(() => {
                if (callback) return callback();
            })
            .catch(err => {
                console.log(err);
            });
    },

    clearActiveSequence() {
        store.commit('setActiveSequence', {});
        store.commit('setSequenceCards', []);
        store.commit('setOriginalSequenceCards', []);
    },

    updateNewSequence(sequence, cards) {
        store.commit('setActiveSequence', sequence);
        store.commit('setOriginalSequenceCards', cards);
    },

    checkSequenceChanges(name) {
        console.log('checking changes');

        if (name && name != store.getters.getActiveSequence.name) {
            store.commit('setSequenceStatus', true);
            return;
        }
        if (
            store.getters.getSequenceCards.length !==
            store.getters.getOriginalSequenceCards.length
        ) {
            store.commit('setSequenceStatus', true);
            // return false;
            return;
        }

        for (let i = store.getters.getSequenceCards.length; i--;) {
            console.log(store.getters.getSequenceCards[i]);
            if (
                store.getters.getSequenceCards[i] !==
                store.getters.getOriginalSequenceCards[i]
            ) {
                store.commit('setSequenceStatus', true);
                // return false;
                return;
            }
        }

        store.commit('setSequenceStatus', false);
        return true;
    },

    /**
    * Products
    */

    getProducts() {
        getResource(`/v1/products/list`)
            .then(res => {
                if (res.status === 'success') {
                    return store.commit('setProducts', res.products);
                }
                if (res.status === 'error') return console.log(res.error);
            })
            .catch(err => console.log(err))
    },

    getProductGroups() {
        getResource(`/v1/productgroups/list`)
            .then(res => {
                store.commit('setAllProductGroups', res.groups);
                if (res.status === 'error') return console.log(res.error);
            })
            .catch(err => console.log(err))
    },

    setActiveProduct(productId, callback) {
        getResource(`/v1/products/single?id=${productId}`)
            .then(res => {
                if (res.status === 'success') {
                    console.log('active product', res.product);
                    return store.commit('setActiveProduct', res.product);
                }
                if (res.status === 'error') return console.log(res.error);
            })
            .then(() => {
                if (callback) return callback();
            })
            .catch(err => console.log(err));
    },

    setActiveProductGroup(productGroupId, callback) {
        getResource(`/v1/productgroups/single?id=${productGroupId}`)
            .then(res => {
                if (res.status === 'success') {
                    console.log('active product group', res.productGroup);
                    return store.commit('setActiveProductGroup', res.productGroup);
                }
                if (res.status === 'error') return console.log(res.error);
            })
            .then(() => {
                if (callback) return callback();
            })
            .catch(err => console.log(err));
    },

    clearActiveProduct() {
        store.commit('setActiveProduct', {});
    },

    clearActiveProductGroup() {
        store.commit('setActiveProductGroup', {});
    },

    /**
    * Media Libraries
    */
    getMediaLibraries() {
        getResource(`/v1/medialibraries/list`)
            .then(res => {
                if (res.status === 'success') {
                    return store.commit('setAllMediaLibraries', res.libraries);
                }
                if (res.status === 'error') return res.error;
            })
            .catch(err => console.log(err));
    },

    /**
    * Misc
    */

    getFlagUrl(market) {
        if (market && market.region) {

            // check for countries who have mismatching first two characters of 2- and 3-letter country codes
            const mismatchCountries = [
                {
                    code: 'ALA',
                    flag: 'AX'
                },
                {
                    code: 'AND',
                    flag: 'AD'
                },
                {
                    code: 'AGO',
                    flag: 'AO'
                },
                {
                    code: 'ATA',
                    flag: 'AQ'
                },
                {
                    code: 'ATG',
                    flag: 'AG'
                },
                {
                    code: 'ARM',
                    flag: 'AM'
                },
                {
                    code: 'ABW',
                    flag: 'AW'
                },
                {
                    code: 'AUT',
                    flag: 'AT'
                },
                {
                    code: 'BHS',
                    flag: 'BS'
                },
                {
                    code: 'BGD',
                    flag: 'BD'
                },
                {
                    code: 'BRB',
                    flag: 'BB'
                },
                {
                    code: 'BLR',
                    flag: 'BY'
                },
                {
                    code: 'BLZ',
                    flag: 'BZ'
                },
                {
                    code: 'BEN',
                    flag: 'BJ'
                },
                {
                    code: 'BES',
                    flag: 'BQ'
                },
                {
                    code: 'BIH',
                    flag: 'BA'
                },
                {
                    code: 'BRN',
                    flag: 'BN'
                },
                {
                    code: 'BDI',
                    flag: 'BI'
                },
                {
                    code: 'CPV',
                    flag: 'CV'
                },
                {
                    code: 'CYM',
                    flag: 'KY'
                },
                {
                    code: 'CAF',
                    flag: 'CF'
                },
                {
                    code: 'CHL',
                    flag: 'CL'
                },
                {
                    code: 'CHN',
                    flag: 'CN'
                },
                {
                    code: 'COM',
                    flag: 'KM'
                },
                {
                    code: 'COG',
                    flag: 'CG'
                },
                {
                    code: 'COK',
                    flag: 'CK'
                },
                {
                    code: 'CUW',
                    flag: 'CW'
                },
                {
                    code: 'DNK',
                    flag: 'DK'
                },
                {
                    code: 'SLV',
                    flag: 'SV'
                },
                {
                    code: 'GNQ',
                    flag: 'GQ'
                },
                {
                    code: 'EST',
                    flag: 'EE'
                },
                {
                    code: 'SWZ',
                    flag: 'SZ'
                },
                {
                    code: 'FLK',
                    flag: 'FK'
                },
                {
                    code: 'FRO',
                    flag: 'FO'
                },
                {
                    code: 'GUF',
                    flag: 'GF'
                },
                {
                    code: 'PYF',
                    flag: 'PF'
                },
                {
                    code: 'GRL',
                    flag: 'GL'
                },
                {
                    code: 'GRD',
                    flag: 'GD'
                },
                {
                    code: 'GLP',
                    flag: 'GP'
                },
                {
                    code: 'GIN',
                    flag: 'GN'
                },
                {
                    code: 'GNB',
                    flag: 'GW'
                },
                {
                    code: 'GUY',
                    flag: 'GY'
                },
                {
                    code: 'IRQ',
                    flag: 'IQ'
                },
                {
                    code: 'IRL',
                    flag: 'IE'
                },
                {
                    code: 'ISR',
                    flag: 'IL'
                },
                {
                    code: 'JAM',
                    flag: 'JM'
                },
                {
                    code: 'KAZ',
                    flag: 'KZ'
                },
                {
                    code: 'PRK',
                    flag: 'KP'
                },
                {
                    code: 'KOR',
                    flag: 'KR'
                },
                {
                    code: 'LBR',
                    flag: 'LR'
                },
                {
                    code: 'LBY',
                    flag: 'LY'
                },
                {
                    code: 'MAC',
                    flag: 'MO'
                },
                {
                    code: 'MDG',
                    flag: 'MG'
                },
                {
                    code: 'MDV',
                    flag: 'MV'
                },
                {
                    code: 'MLT',
                    flag: 'MT'
                },
                {
                    code: 'MTQ',
                    flag: 'MQ'
                },
                {
                    code: 'MYT',
                    flag: 'YT'
                },
                {
                    code: 'MEX',
                    flag: 'MX'
                },
                {
                    code: 'FSM',
                    flag: 'FM'
                },
                {
                    code: 'MNE',
                    flag: 'ME'
                },
                {
                    code: 'MOZ',
                    flag: 'MZ'
                },
                {
                    code: 'NIU',
                    flag: 'NU'
                },
                {
                    code: 'MNP',
                    flag: 'MP'
                },
                {
                    code: 'PAK',
                    flag: 'PK'
                },
                {
                    code: 'PLW',
                    flag: 'PW'
                },
                {
                    code: 'PNG',
                    flag: 'PG'
                },
                {
                    code: 'PRY',
                    flag: 'PY'
                },
                {
                    code: 'PCN',
                    flag: 'PN'
                },
                {
                    code: 'POL',
                    flag: 'PL'
                },
                {
                    code: 'PRT',
                    flag: 'PT'
                },
                {
                    code: 'MAF',
                    flag: 'MF'
                },
                {
                    code: 'SPM',
                    flag: 'PM'
                },
                {
                    code: 'SEN',
                    flag: 'SN'
                },
                {
                    code: 'SRB',
                    flag: 'RS'
                },
                {
                    code: 'SYC',
                    flag: 'SC'
                },
                {
                    code: 'SVK',
                    flag: 'SK'
                },
                {
                    code: 'SVN',
                    flag: 'SI'
                },
                {
                    code: 'SLB',
                    flag: 'SB'
                },
                {
                    code: 'SGS',
                    flag: 'GS'
                },
                {
                    code: 'SUR',
                    flag: 'SR'
                },
                {
                    code: 'SWE',
                    flag: 'SE'
                },
                {
                    code: 'TUN',
                    flag: 'TN'
                },
                {
                    code: 'TUR',
                    flag: 'TR'
                },
                {
                    code: 'TKM',
                    flag: 'TM'
                },
                {
                    code: 'TUV',
                    flag: 'TV'
                },
                {
                    code: 'UKR',
                    flag: 'UA'
                },
                {
                    code: 'ARE',
                    flag: 'AE'
                },
                {
                    code: 'URY',
                    flag: 'UY'
                },
                {
                    code: 'WLF',
                    flag: 'WF'
                },
                {
                    code: 'ESH',
                    flag: 'EH'
                }
            ];

            if (mismatchCountries.some(country => country.code === market.country)) {
                const flag = mismatchCountries.find(country => country.code === market.country).flag;
                return `https://www.countryflags.io/${flag}/flat/48.png`;
            }

            const flag = market.region.substring(0, market.region.length - 1);
            return `https://www.countryflags.io/${flag}/flat/48.png`;

        }

        // no market sent
        return '';
    }
};



// WEBPACK FOOTER //
// ./src/services/Services.js